<script setup lang="ts">
import { LAWYER_INFO } from '@/pages/lawyer/model/keys';

const isMobile: boolean = useIsMobile();
const lawyerInfo = inject(LAWYER_INFO);

const workplaces = computed(() => lawyerInfo?.value?.workplaces ?? []);

const getYear = (date?: string): string =>
  date ? `${new Date(date).getFullYear()} г` : 'по н.в.';
</script>

<template>
  <div :class="['experience-block', { _mobile: isMobile }]">
    <ul v-if="workplaces.length" class="experience-block__list">
      <li
        v-for="workplace in workplaces"
        :key="workplace.id"
        class="experience-block__item"
      >
        <div class="experience-block__item-title">{{ workplace.title }}</div>
        <div class="experience-block__item-period">
          {{ getYear(workplace.date_start) }} - {{ getYear(workplace.date_end) }}
        </div>
      </li>
    </ul>
    <div v-else class="experience-block__empty">
      Автор профиля пока не указал информацию о местах работы
    </div>
  </div>
</template>
